<template>
	<div>
		<MileageSummary></MileageSummary>

		<DetailTitle title="조회 기간"></DetailTitle>

		<form @submit.prevent="onSubmitForm">
			<MileageSearchDate ref="search"></MileageSearchDate>
		</form>

		<DetailCardContainer>
			<div v-for="item in mileageDetail" :key="item.ROWNUM">
				<DetailCard
					:headContent="getHeadContent(item)"
					:detailContent="getDetailContent(item)"
					detailLarge
				>
					<template v-slot:title>
						<div class="column col-auto">{{ getTitle(item) }}</div>
					</template>
				</DetailCard>
			</div>
		</DetailCardContainer>

		<InfiniteLoading
			@infinite="infiniteHandler"
			spinner="circles"
			ref="infiniteLoading"
		>
			<div slot="no-more"></div>
			<div slot="no-results">조회 결과가 없습니다.</div>
		</InfiniteLoading>
	</div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

import { getDateStr, numberWithCommas } from '@/utils/util';
import { fetchMileageDetail } from '@/api';

import MileageSummary from './MileageSummary';
import MileageSearchDate from './MileageSearchDate';

import DetailTitle from '@/components/common/DetailTitle';
import DetailCardContainer from '@/components/common/DetailCardContainer';
import DetailCard from '@/components/common/DetailCard';

const INCREMENT_COUNT = 24; // 조회 결과 증가 개수

export default {
	components: {
		InfiniteLoading,
		MileageSummary,
		MileageSearchDate,
		DetailTitle,
		DetailCardContainer,
		DetailCard,
	},
	data() {
		return {
			limit: INCREMENT_COUNT,
			mileageDetail: [],
		};
	},
	computed: {
		userId() {
			return this.$store.state.userStore.user.user_id;
		},
		rangeStart() {
			return getDateStr(this.$refs.search.range.start);
		},
		rangeEnd() {
			return getDateStr(this.$refs.search.range.end);
		},
	},
	methods: {
		async renderMileageDetail(state) {
			const params = {
				userId: this.userId,
				searchFromDate: this.rangeStart,
				searchToDate: this.rangeEnd,
				rowCount: this.limit,
			};

			const { data } = await fetchMileageDetail(params);

			setTimeout(() => {
				if (data.code === '00000') {
					this.mileageDetail = data.mileageDetail;

					if (state) {
						this.setInfiniteState(data, state);
					}
				}
			}, 500);
		},
		getTitle(data) {
			const date = data.INPUT_DATE;
			const dataStr = `${date.substr(0, 4)}.${date.substr(4, 2)}.${date.substr(
				6,
				2,
			)}`;

			return `발생 일자 : ${dataStr}`;
		},
		getHeadContent(data) {
			const price = numberWithCommas(data.HP_SALE_AMT);
			return {
				name: '결제 금액',
				value: `${price}원`,
			};
		},
		getDetailContent(data) {
			return [
				{
					id: 1,
					name: '결제 내역',
					value: data.SV_NAME,
				},
				{
					id: 2,
					name: '적립 마일리지',
					value: numberWithCommas(data.MILEAGE) + '마일',
				},
				{
					id: 3,
					name: '사용 마일리지',
					value: numberWithCommas(data.USE_MILEAGE) + '마일',
				},
				{
					id: 4,
					name: '소멸 마일리지',
					value: numberWithCommas(data.EXTIN_AMT) + '마일',
				},
			];
		},
		infiniteHandler(state) {
			this.renderMileageDetail(state);
		},
		setInfiniteState(data, state) {
			const mileageDetail = data.mileageDetail;
			const totalCount = data.totalCount;

			if (mileageDetail && mileageDetail.length) {
				if (this.limit > totalCount) {
					state.complete();
				} else {
					state.loaded();
				}

				this.limit += INCREMENT_COUNT;
			} else {
				state.complete();
			}
		},
		onSubmitForm() {
			this.resetResult();
			this.$refs.infiniteLoading.stateChanger.reset();
		},
		resetResult() {
			this.limit = 0;
			this.mileageDetail = [];
		},
	},
};
</script>
